<div class="px-8 py-4 shadow-md">
  <a routerLink="/"><h1 class="text-2xl">Bärner Wallet</h1></a>
</div>
<div class="container">
  <router-outlet></router-outlet>
</div>
